__turbopack_context__.v({
  "bar": "ProgressBar-module-scss-module__hhyiYa__bar",
  "blockBar": "ProgressBar-module-scss-module__hhyiYa__blockBar",
  "blockWrapper": "ProgressBar-module-scss-module__hhyiYa__blockWrapper",
  "wrapper": "ProgressBar-module-scss-module__hhyiYa__wrapper",
});
